import React from 'react';
import PropTypes from 'prop-types';

import InputLabel from '../../../../components/v2/InputLabel';
import {
  StyledTextField,
} from './styles';

const Input = ({
  className,
  name,
  label,
  ...extraProps
}) => (
  <>
    {!!label && <InputLabel>{label}</InputLabel>}
    <StyledTextField
      className={className}
      name={name}
      {...extraProps}
    />
  </>
);

Input.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
};

Input.defaultProps = {
  className: '',
  name: '',
  label: '',
};

export default Input;
